import React, { useState, useEffect } from 'react';
import Axios from "axios";
import { Grid, Typography, CircularProgress, Container, Box, Button } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CardComponent from './PiacComponents/CardComponent';

function WinterSportsListings() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const { config, environment } = require('../../index');

  useEffect(() => {
    const source = Axios.CancelToken.source();
    async function fetchListings() {
      try {
        const response = await Axios.get(`${config[environment].sportEquipmentEndpoint}?season=Winter`, { cancelToken: source.token });
        const processedListings = response.data.map(l => ({ ...l, key: 'Telisportfelszereles' }));
        setListings(processedListings);
        setLoading(false);
      } catch (error) {
        if (!Axios.isCancel(error)) {
          console.error("Error fetching winter sports listings:", error);
          setLoading(false);
        }
      }
    }
    fetchListings();
    return () => source.cancel();
  }, [config, environment]);

  if (loading) {
    return (
      <Grid container justifyContent="center" alignItems="center" sx={{ height: "100vh" }}>
        <CircularProgress />
      </Grid>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4, mt: '50px' }}>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" sx={{ color: 'var(--sznodarkblue)', fontWeight: 'bold' }}>
          {t('SubMenu.WinterSports')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
            <Button variant="contained" onClick={() => navigate('/add-winter-sport')} sx={{ bgcolor: '#2492be' }}>
              {t('SubMenu.WinterSports') + " +"}
            </Button>
            <Button variant="contained" onClick={() => navigate('/telisportfelszereles-terkep')} sx={{ bgcolor: 'green' }}>
              {t('Map.ShowOnMap', 'Megtekintés térképen')}
            </Button>
            <Button variant="contained" onClick={() => navigate('/terkep')}>
              {t('Map.BackToMap')}
            </Button>
        </Box>
      </Box>
      <Grid container spacing={3}>
        {listings.length === 0 ? (
          <Typography variant="h6" sx={{ mt: 4, width: '100%', textAlign: 'center' }}>
            {t('Market.NoListings', 'Jelenleg nincs elérhető hirdetés.')}
          </Typography>
        ) : (
          listings.map((listing) => (
            <Grid item xs={12} sm={6} md={4} key={listing.id}>
              <CardComponent 
                listing={listing} 
                state={{ mapInstance: null }} 
                setFlyToLocation={() => {}} 
                navigate={navigate} 
              />
            </Grid>
          ))
        )}
      </Grid>
    </Container>
  );
}

export default WinterSportsListings;
